module.exports = __webpack_public_path__ + "static/media/validacao_qualquer_coisa_white.57832860.svg";